<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<!-- <h4 class="text_info" >This feature is under development</h4>

<div>
  <img src="./assets/img/Bargraph.png" alt="">
</div> -->


<div class="dashboard-page" *ngIf="dashboardData">
  <div class="page-header">
    <div>
      <h1>Menu Analytics Dashboard</h1>
      <p>Operational insights, allergies, dietary preferences, compliance, and planning.</p>
    </div>

    <div class="global-filter">
      <label for="timeFilter">Time Filter</label>
      <select id="timeFilter" [(ngModel)]="selectedTimeFilter" (ngModelChange)="onTimeFilterChange()">
        <option *ngFor="let filter of timeFilters" [value]="filter.value">
          {{ filter.label }}
        </option>
      </select>
    </div>
  </div>

  <div class="summary-grid">
    <div class="summary-card" *ngFor="let card of dashboardData.summaryCards">
      <div class="summary-title">{{ card.title }}</div>
      <div class="summary-value">{{ card.value | number }}</div>
      <div class="summary-subtitle">{{ card.subtitle }}</div>
    </div>
  </div>

  <div class="chart-grid">
    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Number of People with Dietary Preferences</h3>
          <p>Count of diners avoiding specific ingredients</p>
        </div>
      </div>

      <apx-chart *ngIf="chartsReady" [series]="dietaryPreferencesChart.series!" [chart]="dietaryPreferencesChart.chart!"
        [xaxis]="dietaryPreferencesChart.xaxis!" [yaxis]="dietaryPreferencesChart.yaxis!"
        [plotOptions]="dietaryPreferencesChart.plotOptions!" [dataLabels]="dietaryPreferencesChart.dataLabels!"
        [colors]="dietaryPreferencesChart.colors!" [grid]="dietaryPreferencesChart.grid!"
        [tooltip]="dietaryPreferencesChart.tooltip!" [legend]="dietaryPreferencesChart.legend!"></apx-chart>
    </div>

    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Number of People with Food Allergies</h3>
          <p>Count of diners with allergies to specific ingredients</p>
        </div>
      </div>

      <apx-chart *ngIf="chartsReady" [series]="foodAllergiesChart.series!" [chart]="foodAllergiesChart.chart!"
        [xaxis]="foodAllergiesChart.xaxis!" [yaxis]="foodAllergiesChart.yaxis!"
        [plotOptions]="foodAllergiesChart.plotOptions!" [dataLabels]="foodAllergiesChart.dataLabels!"
        [colors]="foodAllergiesChart.colors!" [grid]="foodAllergiesChart.grid!" [tooltip]="foodAllergiesChart.tooltip!"
        [legend]="foodAllergiesChart.legend!"></apx-chart>
    </div>

    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Percentage Distribution of Food Allergies</h3>
          <p>Breakdown of reported allergies by type</p>
        </div>
      </div>

      <apx-chart *ngIf="chartsReady" [series]="allergyDistributionChart.series!"
        [chart]="allergyDistributionChart.chart!" [labels]="allergyDistributionChart.labels!"
        [colors]="allergyDistributionChart.colors!" [legend]="allergyDistributionChart.legend!"
        [dataLabels]="allergyDistributionChart.dataLabels!" [tooltip]="allergyDistributionChart.tooltip!"
        [responsive]="allergyDistributionChart.responsive!"></apx-chart>
    </div>

    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Food Preferences Across Dietary Types</h3>
          <p>Vegan and vegetarian preferences by category</p>
        </div>
      </div>

      <apx-chart *ngIf="chartsReady" [series]="preferenceByCategoryChart.series!"
        [chart]="preferenceByCategoryChart.chart!" [xaxis]="preferenceByCategoryChart.xaxis!"
        [yaxis]="preferenceByCategoryChart.yaxis!" [plotOptions]="preferenceByCategoryChart.plotOptions!"
        [dataLabels]="preferenceByCategoryChart.dataLabels!" [colors]="preferenceByCategoryChart.colors!"
        [grid]="preferenceByCategoryChart.grid!" [tooltip]="preferenceByCategoryChart.tooltip!"
        [legend]="preferenceByCategoryChart.legend!" [stroke]="preferenceByCategoryChart.stroke!"></apx-chart>
    </div>
  </div>

  <div class="two-column-grid">
    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Top Performing Dishes - Similar Cuisine</h3>
          <p>Best dishes from restaurants serving similar cuisines</p>
        </div>
        <span class="chip">{{ dashboardData.topCuisineTitle }}</span>
      </div>

      <div class="dish-list">
        <div class="dish-card" *ngFor="let dish of dashboardData.topCuisineDishes">
          <div class="dish-main">
            <div class="dish-name-row">
              <h4>{{ dish.name }}</h4>
              <span class="tag">{{ dish.tag }}</span>
            </div>
            <div class="dish-restaurant">{{ dish.restaurant }}</div>
          </div>

          <div class="dish-stats">
            <div class="rating">★ {{ dish.rating }}</div>
            <div class="trend">↗ {{ dish.trendValue }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Top Performing Dishes - Similar Category</h3>
          <p>Best dishes from similar menu categories</p>
        </div>
        <span class="chip">{{ dashboardData.topCategoryTitle }}</span>
      </div>

      <div class="dish-list">
        <div class="dish-card" *ngFor="let dish of dashboardData.topCategoryDishes">
          <div class="dish-main">
            <div class="dish-name-row">
              <h4>{{ dish.name }}</h4>
              <span class="tag">{{ dish.tag }}</span>
            </div>
            <div class="dish-restaurant">{{ dish.restaurant }}</div>
          </div>

          <div class="dish-stats">
            <div class="rating">★ {{ dish.rating }}</div>
            <div class="trend">↗ {{ dish.trendValue }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="two-column-grid">
    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Regulatory Compliance Status</h3>
          <p>Current regulatory requirements and updates</p>
        </div>
      </div>

      <div class="compliance-list">
        <div class="compliance-item" *ngFor="let item of dashboardData.complianceItems">
          <div class="compliance-left">
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
            <span class="updated-text">Last updated: {{ item.updatedOn }}</span>
          </div>

          <!-- <span class="status-pill" [ngClass]="item.status">
            {{ item.status }}
          </span> -->
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-header">
        <div>
          <h3>Menu Planning Resources</h3>
          <p>Helpful information for strategic menu planning</p>
        </div>
      </div>

      <div class="resource-list">
        <div class="resource-card" *ngFor="let resource of dashboardData.resources">
          <h4>{{ resource.title }}</h4>
          <ul>
            <li *ngFor="let point of resource.points">{{ point }}</li>
          </ul>
          <span class="updated-text">Last updated: {{ resource.updatedOn }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="panel">
    <div class="panel-header">
      <div>
        <h3>6-Month Planning Calendar</h3>
        <p>Important dates for menu planning and operations</p>
      </div>
    </div>

    <div class="calendar-grid">
      <div class="month-card" *ngFor="let month of dashboardData.planningMonths">
        <h4>{{ month.month }}</h4>

        <ng-container *ngIf="month.events.length; else noMonthEvents">
          <div class="calendar-event" *ngFor="let event of month.events">
            <div class="event-day">{{ event.day }}</div>

            <div class="event-body">
              <div class="event-title">{{ event.title }}</div>
              <span class="event-badge" [ngClass]="event.type">{{ event.type }}</span>
              <div class="event-description">{{ event.description }}</div>
            </div>
          </div>
        </ng-container>

        <ng-template #noMonthEvents>
          <div class="empty-month">No events available</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>